import { twMerge } from 'tailwind-merge';

interface CardBaseProps {
  className?: string;
  children: React.ReactNode;
}

export const CardBase = ({ className, children }: CardBaseProps) => {
  return (
    <div
      className={twMerge(
        'rounded-main flex flex-col overflow-x-hidden overflow-y-hidden p-10',
        className
      )}
    >
      {children}
    </div>
  );
};
